import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./DiscountCode.css";
import MainInput from "../../Elements/MainInput/MainInput";

const DiscountCode = ({ onApply, promocodeData }) => {
  const { t } = useTranslation();
  const [code, setCode] = useState("");
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState("");
  const [isApplying, setIsApplying] = useState(false);

  useEffect(() => {
    if (!!promocodeData) {
      setStatus("success");
      setMessage(t("cart.applied"));
    } else if (code.trim()) {
      setStatus("error");
      setMessage(t("cart.invalidCode"));
    }
  }, [promocodeData, t]);

  const handleApply = async () => {
    const trimmed = code.trim();
    if (!trimmed) return;

    setStatus(null);
    setMessage("");

    try {
      await onApply(trimmed);
    } catch (err) {
      setStatus("error");
      setMessage(t("cart.invalidCode"));
    }
  };

  return (
    <div className="discount-wrapper">
      <div className="discount-input-box">
        <MainInput
          value={code}
          onChange={(e) => {
            setCode(e.target.value);
            setStatus(null);
            setMessage("");
          }}
          placeholder={t("cart.discountCode")}
          name="discountCode"
        />

        <button className="offers-toggle-btn discount-apply-btn" type="button" onClick={handleApply}>
          {t("cart.applyCode")}
        </button>
        {message && (
          <span
            className={
              status === "success"
                ? "discount-message discount-message--success"
                : "discount-message discount-message--error"
            }
          >
            {message}
          </span>
        )}
      </div>
    </div>
  );
};

export default DiscountCode;
